import { buildFullURL, getBaseURL } from "../../api/axiosTemp";

export const isFullUrl = (url: string) => /^https?:\/\//.test(url);

export const buildAssetUrl = (url = "") => {
  if (!url) return "";
  const customBaseURL = getBaseURL();
  if (isFullUrl(url)) return url;
  return customBaseURL
    ? buildFullURL(customBaseURL, url)
    : buildFullURL(window.location.origin, url);
};

export const getEmailDomain = (email = "") => {
  if (typeof email !== "string") return "";
  const normalized = email.trim().toLowerCase();
  const atIndex = normalized.lastIndexOf("@");
  if (atIndex < 0) return "";
  return normalized.slice(atIndex + 1);
};
